import React, { useMemo } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { homeFor } from '../lib/constants';

export default function ProtectedRoute({ children, requireKind }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  const redirectState = useMemo(() => ({ from: location }), [location]);
  if (loading) return <div data-testid="protected-route-loading" className="min-h-screen flex items-center justify-center bg-slate-50 text-slate-500 text-sm">Loading…</div>;
  if (!user) return <Navigate to="/login" state={redirectState} replace />;
  if (requireKind && user.kind !== requireKind) return <Navigate to={homeFor(user)} replace />;
  if (user.pinSetupRequired && location.pathname !== '/portal/pin-setup') return <Navigate to="/portal/pin-setup" replace />;
  return children;
}
